import { ErrorBoundary } from "@kaltura/mediaspace-shared-ui";
import { baseUrl, fetchKmsData } from "@kaltura/mediaspace-shared-utils";
import { Suspense, useMemo } from "react";
import CreateTownhallForm, { CreateTownhallFormProps } from "./CreateTownhallForm";
import FormSkeleton from "./skeleton/FormSkeleton";
import { Template } from "@kaltura/mediaspace-shared-ui/controlled-form";

export interface CreateTownhallFormContainerProps extends Omit<CreateTownhallFormProps, "fetchTemplates"> {
    /**
     * URL to fetch templates from
     */
    templatesUrl: string;
}

export function CreateTownhallFormContainer({ templatesUrl, ...rest }: CreateTownhallFormContainerProps) {
    const fetchTemplatesData = useMemo(() => {
        return fetchKmsData<Template[]>(`${baseUrl}${templatesUrl}`);
    }, [templatesUrl]);

    return (
        <ErrorBoundary fallback={<FormSkeleton />}>
            <Suspense fallback={<FormSkeleton />}>
                <CreateTownhallForm {...rest} fetchTemplates={fetchTemplatesData} />
            </Suspense>
        </ErrorBoundary>
    );
}

export default CreateTownhallFormContainer;
